<div class="content-wrapper" autoscroll>
    <div class="container-xxl flex-grow-1 container-p-y">
        <h4 class="fw-bold py-3 " style="font-size: 17px;margin-left:20px; margin-top: 0.5cm;">
            <span class="text-muted fw-light">Payments /</span> Payment Transaction
        </h4>

        <mat-card>
            <mat-card-header class="mt-3 mb-4">
                <mat-icon style="margin-right: 10px;margin-top: -0.5px;">payments</mat-icon>Payment Transaction
            </mat-card-header>

            <mat-card-actions>
                <div class="d-flex align-items-start align-items-sm-center">
                    <div class="col-md-12 col-lg-12">
                        <div class="nav-align-top mb-4">
                            <ul class="nav nav-pills mb-3 nav-fill" role="tablist">

                                <mat-list class="nav-item">
                                    <button mat-button color="primary" type="button" class="nav-link active" role="tab"
                                        data-bs-toggle="tab" data-bs-target="#navs-pills-justified-payments"
                                        aria-controls="navs-pills-justified-payments" aria-selected="true">Payments
                                    </button>
                                </mat-list>

                                <mat-list class="nav-item">
                                    <button mat-button color="primary" type="button" class="nav-link" role="tab"
                                        data-bs-toggle="tab" data-bs-target="#navs-pills-justified-settlements"
                                        aria-controls="navs-pills-justified-settlements"
                                        aria-selected="false">Settlements
                                    </button>
                                </mat-list>

                                <mat-list class="nav-item">
                                    <button mat-button color="primary" type="button" class="nav-link" role="tab"
                                        data-bs-toggle="tab" data-bs-target="#navs-pills-justified-remittances"
                                        aria-controls="navs-pills-justified-remittances"
                                        aria-selected="false">Remittance
                                    </button>
                                </mat-list>
                            </ul>
                        </div>
                    </div>
                </div>
            </mat-card-actions>
            <hr class="my-0 mt-3 mb-4" />
            <mat-card-content>
                <!-- payment transaction -->
                <div class="tab-content">
                    <div class="tab-pane fade show active" id="navs-pills-justified-payments" role="tabpanel">
                        <form [formGroup]="paymentTransactionForm" (ngSubmit)="onSearch()">
                            <div class="row">
                                <div class="col-md-6">
                                    <mat-card class="mb-3">
                                        <mat-card-header class="mt-2 mb-2">
                                            <mat-icon
                                                style="margin-right: 8px;margin-top: -0.3px;">calendar_month</mat-icon>Date</mat-card-header>
                                        <mat-card-content>
                                            <div class="adminControls">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>From Date</mat-label>
                                                    <input matInput [matDatepicker]="picker" formControlName="fromDate"
                                                        required>
                                                    <mat-hint>MM/DD/YYYY</mat-hint>
                                                    <mat-datepicker-toggle matSuffix
                                                        [for]="picker"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker></mat-datepicker>
                                                </mat-form-field>

                                                <mat-form-field appearance="outline">
                                                    <mat-label>To Date</mat-label>
                                                    <input matInput [matDatepicker]="picker1" formControlName="toDate"
                                                        required>
                                                    <mat-hint>MM/DD/YYYY</mat-hint>
                                                    <mat-datepicker-toggle matSuffix
                                                        [for]="picker1"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker1></mat-datepicker>
                                                </mat-form-field>
                                            </div>
                                        </mat-card-content>
                                    </mat-card>
                                </div>

                                <div class="col-md-6">
                                    <mat-card>
                                        <mat-card-header class="mt-2 mb-2">
                                            <mat-icon
                                                style="margin-right: 8px;margin-top: -0.3px;">credit_card</mat-icon>Card
                                            Details</mat-card-header>
                                        <mat-card-content>
                                            <div class="adminControls">
                                                <mat-grid-list cols="2" rowHeight="80px">
                                                    <mat-grid-tile>
                                                        <div class="adminControls">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>First Four digit</mat-label>
                                                                <input matInput type="text" formControlName="firstFour"
                                                                    (input)="onPressff($event)" appNumericOnly
                                                                    appNumeric autocomplete="off">
                                                            </mat-form-field>
                                                        </div>
                                                    </mat-grid-tile>
                                                    <!-- {{this.paymentTransactionForm.value.firstFour }} -->
                                                    <mat-grid-tile>
                                                        <div class="adminControls">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>Last Four digit</mat-label>
                                                                <input matInput type="text" formControlName="lastFour"
                                                                    (input)="onPresslf($event)" appNumericOnly
                                                                    appNumeric autocomplete="off">
                                                            </mat-form-field>
                                                        </div>
                                                    </mat-grid-tile>
                                                </mat-grid-list>

                                                <mat-form-field appearance="outline"
                                                    style="width: 96%;margin-left: 2%;margin-right: 2%;">
                                                    <mat-label>Card Holder Name</mat-label>
                                                    <input matInput type="text" formControlName="cardHolderName"
                                                        [matAutocomplete]="autoname">
                                                </mat-form-field>

                                                <mat-autocomplete #autoname>
                                                    <mat-option *ngFor="let result of searchCardName" [value]="result">
                                                        {{ result }}
                                                    </mat-option>
                                                </mat-autocomplete>
                                            </div>
                                        </mat-card-content>
                                    </mat-card>
                                </div>
                            </div>

                            <mat-card class="mt-3">
                                <mat-card-header class="mt-2 mb-4">
                                    <mat-icon style="margin-right: 8px;margin-top: -0.3px;">assignment</mat-icon>
                                    Service Information
                                </mat-card-header>
                                <mat-card-content class="mt-3 mb-3">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <div class="adminControls">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Service Type</mat-label>
                                                    <mat-select formControlName="serviceType" disabled>
                                                        <mat-option value="A">Service A</mat-option>
                                                        <mat-option value="B">Appraisal Fee Service</mat-option>
                                                        <mat-option value="C">Service B</mat-option>
                                                    </mat-select>
                                                    <mat-error>This field is required</mat-error>
                                                </mat-form-field>

                                                <mat-form-field appearance="outline">
                                                    <mat-label>Loan ID</mat-label>
                                                    <input matInput formControlName="loan" [matAutocomplete]="autoloan">
                                                </mat-form-field>
                                                <mat-autocomplete #autoloan>
                                                    <mat-option *ngFor="let result of searchLoan" [value]="result">
                                                        {{ result }}
                                                    </mat-option>
                                                </mat-autocomplete>

                                                <mat-form-field appearance="outline">
                                                    <mat-label>AFS Status</mat-label>
                                                    <mat-select id="paymentStatusId" formControlName="paymentStatusId"
                                                        name="afsStatus">
                                                        <mat-option value=1>Open</mat-option>
                                                        <mat-option value=17>Expired</mat-option>
                                                        <mat-option value=14>Refunded</mat-option>
                                                        <mat-option value=19>Remitted</mat-option>
                                                        <mat-option value=3>Settled</mat-option>
                                                        <mat-option value=11>Cancelled</mat-option>
                                                        <mat-option value=7>Rejected</mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div>

                                        <div class="col-md-3">
                                            <div class="adminControls">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Tracking Number</mat-label>
                                                    <input matInput id="trackingNumber" formControlName="trackingNumber"
                                                        name="trackingNumber" [matAutocomplete]="autotrack">
                                                </mat-form-field>

                                                <mat-autocomplete #autotrack>
                                                    <mat-option *ngFor="let result of trackingNum" [value]="result">
                                                        {{ result }}
                                                    </mat-option>
                                                </mat-autocomplete>

                                                <mat-form-field appearance="outline">
                                                    <mat-label>Address</mat-label>
                                                    <input matInput formControlName="address"
                                                        [matAutocomplete]="autoadd">
                                                </mat-form-field>

                                                <mat-autocomplete #autoadd>
                                                    <mat-option *ngFor="let result of searchAdd" [value]="result">
                                                        {{ result }}
                                                    </mat-option>
                                                </mat-autocomplete>
                                            </div>
                                        </div>

                                        <div class="col-md-3">
                                            <div class="adminControls">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>State</mat-label>
                                                    <mat-select formControlName="state" name="state" id="state"
                                                        (selectionChange)="onStateClick($event)">
                                                        <mat-option *ngFor="let State of states | slice:3"
                                                            [value]="State">
                                                            {{ State }}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>

                                                <mat-form-field appearance="outline">
                                                    <mat-label>City</mat-label>
                                                    <mat-select formControlName="city" name="city" id="city">
                                                        <mat-option *ngFor="let City of cities" [value]="City">
                                                            {{ City }}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div>

                                        <div class="col-md-3">
                                            <div class="adminControls">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Vendor</mat-label>
                                                    <mat-select id="VendorId" formControlName="vendorId"
                                                        name="vendorId">
                                                        <mat-option *ngFor="let data of this.data" [value]="data">{{
                                                            data }}</mat-option>
                                                    </mat-select>
                                                </mat-form-field>

                                                <mat-form-field appearance="outline">
                                                    <mat-label>Zip Code</mat-label>
                                                    <input matInput formControlName="zipCode" [matAutocomplete]="auto"
                                                        appNumericOnly appNumeric>
                                                </mat-form-field>

                                                <mat-autocomplete #auto>
                                                    <mat-option *ngFor="let result of searchResults" [value]="result">
                                                        {{ result }}
                                                    </mat-option>
                                                </mat-autocomplete>
                                            </div>
                                        </div>
                                    </div>
                                </mat-card-content>
                                <mat-card-actions class="mb-3">
                                    <div class="buttonRow">
                                        <button mat-raised-button class="search" type="submit"><mat-icon
                                                class="icon">search</mat-icon>Search</button>
                                        <button mat-raised-button type="button" class="reset"
                                            (click)="onReset()">Reset</button>
                                    </div>
                                </mat-card-actions>
                            </mat-card>
                        </form>
                        <mat-card class="mt-3 mb-3">
                            <mat-card-actions>
                                <div style="text-align:right;">
                                    <button mat-raised-button class="search" (click)="exportToExcel()"><mat-icon
                                            class="nav-icon">download</mat-icon>Download Excel</button>
                                </div>
                            </mat-card-actions>
                            <mat-card-content>
                                <div class="card">
                                    <table mat-table [dataSource]="dataSource" matSort
                                        (matSortChange)="announceSortChange($event)" class="mat-elevation-z8">
                                        <ng-container matColumnDef="srNo">
                                            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="0"
                                                mat-sort-header [title]="'S.No'">S.No
                                            </th>
                                            <td mat-cell *matCellDef="let item; let j = index">
                                                {{ (j+1) + (myPaginator.pageIndex * myPaginator.pageSize) }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="orderDate">
                                            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="1"
                                                mat-sort-header>
                                                <div class="column-name">Order Date</div>
                                            </th>
                                            <td mat-cell *matCellDef="let element"> {{element.orderDate | date:
                                                'MM/dd/yyyy'}}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="trackingNumber">
                                            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="2"
                                                mat-sort-header>
                                                <div class="column-name">Tracking Number</div>
                                            </th>
                                            <td mat-cell *matCellDef="let element"><a
                                                    [routerLink]="['/All/transactionDetails',element.paymentRequestId]"
                                                    style="text-decoration: none;"> {{element.trackingNumber |
                                                    slice:0:12
                                                    }}{{element.trackingNumber?.length
                                                    > 12 ? '...' : ''}}</a></td>
                                        </ng-container>

                                        <ng-container matColumnDef="loanNumber">
                                            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="3"
                                                mat-sort-header>
                                                <div class="column-name">Loan Number</div>
                                            </th>
                                            <td mat-cell *matCellDef="let element"> {{element.loanNumber}} </td>
                                        </ng-container>

                                        <ng-container matColumnDef="settleDate">
                                            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="4"
                                                mat-sort-header>
                                                <div class="column-name">Settle Date</div>
                                            </th>
                                            <td mat-cell *matCellDef="let element"> {{element.settleDate | date:
                                                'dd/MM/yyyy'}} </td>
                                        </ng-container>


                                        <ng-container matColumnDef="cardHolderName">
                                            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="5"
                                                mat-sort-header>
                                                <div class="column-name">Card Holder Name</div>
                                            </th>
                                            <td mat-cell *matCellDef="let element"> {{element.cardHolderName}} </td>
                                        </ng-container>

                                        <ng-container matColumnDef="borrowerName">
                                            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="6"
                                                mat-sort-header>
                                                <div class="column-name">Borrower Name</div>
                                            </th>

                                            <td mat-cell *matCellDef="let element">
                                                {{element.borrowerName}} </td>
                                        </ng-container>

                                        <ng-container matColumnDef="vendorName">
                                            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="7"
                                                mat-sort-header>
                                                <div class="column-name">Vendor Name</div>
                                            </th>
                                            <td mat-cell *matCellDef="let element"> {{element.vendorId}} </td>
                                        </ng-container>

                                        <ng-container matColumnDef="settleAmount">
                                            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="8"
                                                mat-sort-header>
                                                <div class="column-name">Settle Amount</div>
                                            </th>
                                            <td mat-cell *matCellDef="let element" style="text-align: right;">
                                                $&#8239;{{element.settleAmount}} </td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                                        <tr class="mat-row" *matNoDataRow>
                                            <td class="mat-cell" colspan="9">No data matching the filter
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <mat-card-actions>
                                    <div class="text-align mt-3">
                                        <mat-paginator #myPaginator [length]="25" [pageSize]="5"
                                            [pageSizeOptions]="[5, 10, 25, 100]">
                                        </mat-paginator>
                                    </div>
                                </mat-card-actions>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>

                <!-- Settlement -->
                <div class="tab-content">
                    <div class="tab-pane fade" id="navs-pills-justified-settlements" role="tabpanel">
                        <form [formGroup]="paymentSettlementForm" (ngSubmit)="onSettlementSearch()">

                            <mat-card class="mb-3" style="margin-left: 20%; margin-right: 20%;">
                                <mat-card-header class="mt-2 mb-2">
                                    <mat-icon
                                        style="margin-right: 8px;margin-top: -0.3px;">calendar_month</mat-icon>Date</mat-card-header>
                                <mat-card-content>
                                    <div class="adminControls">
                                        <mat-form-field appearance="outline">
                                            <mat-label>From Date</mat-label>
                                            <input matInput [matDatepicker]="picker2" formControlName="fromSettle"
                                                required>
                                            <mat-hint>MM/DD/YYYY</mat-hint>
                                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                            <mat-datepicker #picker2></mat-datepicker>
                                        </mat-form-field>
                                        <!-- {{this.paymentSettlementForm.value.fromSettle}} -->

                                        <mat-form-field appearance="outline">
                                            <mat-label>To Date</mat-label>
                                            <input matInput [matDatepicker]="picker3" formControlName="toSettle"
                                                required>
                                            <mat-hint>MM/DD/YYYY</mat-hint>
                                            <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                                            <mat-datepicker #picker3></mat-datepicker>
                                        </mat-form-field>
                                    </div>
                                </mat-card-content>
                                <mat-card-actions class="mb-3">
                                    <div class="buttonRow">
                                        <button mat-raised-button class="search" type="submit"><mat-icon
                                                class="icon">search</mat-icon>Search</button>
                                    </div>
                                </mat-card-actions>
                            </mat-card>
                        </form>
                        <mat-card class="mt-3">
                            <mat-card-actions>
                                <div style="text-align:right;">
                                    <button mat-raised-button class="search" (click)="downloadSettleExcel()"><mat-icon
                                            class="nav-icon">download</mat-icon>Download Excel</button>
                                </div>
                            </mat-card-actions>

                            <table mat-table #outerSort="matSort" [dataSource]="settleDataSource" multiTemplateDataRows
                                class="mat-elevation-z8" matSort>
                                <ng-container matColumnDef="{{column}}"
                                    *ngFor="let column of displayedSettleParentColumns; let i = index">
                                    <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="i"
                                        mat-sort-header>
                                        {{
                                        column === 'formattedSettleDate' ? 'Settle Date' :
                                        column === 'numberOfOrders' ? '# of Orders' :
                                        column === 'settleAmount' ? 'Settle Amount' : column
                                        }}
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        <div *ngIf="column==='settleAmount'; else elseBlock" style="text-align: right;">
                                            {{'$'+element[column]}}
                                        </div>
                                        <ng-template #elseBlock>
                                            {{element[column]}}
                                        </ng-template>
                                    </td>
                                </ng-container>

                                <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->

                                <ng-container matColumnDef="expandedDetail">
                                    <td mat-cell *matCellDef="let element"
                                        [attr.colspan]="displayedSettleParentColumns.length">
                                        <div class="example-element-detail" *ngIf="element.settlementDetails?.data"
                                            [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                                            <div class="inner-table mat-elevation-z8" *ngIf="expandedElement">
                                                <div class="settleData">
                                                    <button mat-raised-button class="search"
                                                        (click)="downloadInnerSettleExcel(element.settlementDetails.data)"><mat-icon
                                                            class="nav-icon">download</mat-icon>Download Excel
                                                    </button>
                                                </div>
                                                <mat-form-field>
                                                    <input matInput (keyup)="applyFilter1($event.target.value)"
                                                        placeholder="Filter" />
                                                </mat-form-field>
                                                <table mat-table innerPaginator #innerTables #innerSort="matSort"
                                                    [dataSource]="element.settlementDetails" matSort>
                                                    <ng-container matColumnDef="{{innerColumn}}"
                                                        *ngFor="let innerColumn of displayedSettleChildColumns;let i = index">
                                                        <th mat-header-cell *matHeaderCellDef [resizeColumn]="true"
                                                            [index]="i" mat-sort-header>
                                                            {{
                                                            innerColumn === 'orderDate' ? 'Order Date' :
                                                            innerColumn === 'loanNumber' ? 'Loan Number' :
                                                            innerColumn === 'formattedSettleDate' ? 'Settle Date' :
                                                            innerColumn === 'lenderName' ? 'Lender Name' :
                                                            innerColumn === 'settleAmount' ? 'Settle Amount' :
                                                            innerColumn === 'borrower' ? 'Borrower Name' :
                                                            innerColumn === 'vendorId' ? 'Vendor Name' : column
                                                            }}
                                                        </th>

                                                        <td mat-cell *matCellDef="let element">
                                                            <div *ngIf="innerColumn==='settleAmount'; else elseBlock"
                                                                style="text-align: right;">
                                                                {{'$'+element[innerColumn]}}
                                                            </div>
                                                            <ng-template #elseBlock>
                                                                {{innerColumn=='orderDate'?(element[innerColumn] |
                                                                date:'dd/MM/yyyy'):element[innerColumn]}}
                                                            </ng-template>
                                                        </td>
                                                    </ng-container>
                                                    <tr mat-header-row *matHeaderRowDef="displayedSettleChildColumns">
                                                    </tr>
                                                    <tr mat-row
                                                        *matRowDef="let row; columns: displayedSettleChildColumns;">
                                                    </tr>
                                                </table>
                                                <mat-card-actions>
                                                    <mat-paginator #innerPaginator [pageSize]="5"
                                                        [length]="element.settlementDetails.data.length" [pageIndex]="0"
                                                        [pageSizeOptions]="[5, 10, 25, 100]">
                                                    </mat-paginator>
                                                </mat-card-actions>
                                            </div>
                                        </div>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedSettleParentColumns"></tr>
                                <tr mat-row *matRowDef="let element; columns: displayedSettleParentColumns;"
                                    [class.example-element-row]="element.settlementDetails?.data"
                                    [class.example-expanded-row]="expandedElement === element"
                                    (click)="toggleRow(element)"></tr>
                                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']"
                                    class="example-detail-row"></tr>
                            </table>
                        </mat-card>
                        <mat-card-actions>
                            <div class="text-align mt-3">
                                <mat-paginator #branchPaginator [pageSize]="5" [pageSizeOptions]="[5, 10, 25, 100]">
                                </mat-paginator>
                            </div>
                        </mat-card-actions>
                    </div>
                </div>

                <!-- Remittance -->
                <div class="tab-content">
                    <div class="tab-pane fade" id="navs-pills-justified-remittances" role="tabpanel">
                        <form [formGroup]="paymentRemittanceForm" (ngSubmit)="onRemittanceSearch()">
                            <div class="row">
                                <div class="col-md-6">
                                    <mat-card class="mb-3">
                                        <mat-card-header class="mt-2 mb-2">
                                            <mat-icon
                                                style="margin-right: 8px;margin-top: -0.3px;">calendar_month</mat-icon>Date</mat-card-header>
                                        <mat-card-content>
                                            <div class="adminControls">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>From Date</mat-label>
                                                    <input matInput [matDatepicker]="picker4"
                                                        formControlName="fromRemit" required>
                                                    <mat-hint>MM/DD/YYYY</mat-hint>
                                                    <mat-datepicker-toggle matSuffix
                                                        [for]="picker4"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker4></mat-datepicker>
                                                </mat-form-field>

                                                <mat-form-field appearance="outline">
                                                    <mat-label>To Date</mat-label>
                                                    <input matInput [matDatepicker]="picker5" formControlName="toRemit"
                                                        required>
                                                    <mat-hint>MM/DD/YYYY</mat-hint>
                                                    <mat-datepicker-toggle matSuffix
                                                        [for]="picker5"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker5></mat-datepicker>
                                                </mat-form-field>
                                            </div>
                                        </mat-card-content>
                                    </mat-card>
                                </div>

                                <div class="col-md-6">
                                    <mat-card>
                                        <mat-card-header class="mt-2 mb-2">
                                            <mat-icon
                                                style="margin-right: 8px;margin-top: -0.3px;">information</mat-icon>Other
                                            Details</mat-card-header>
                                        <mat-card-content>
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="adminControls">
                                                        <mat-form-field appearance="outline">
                                                            <mat-label>Vendor</mat-label>
                                                            <mat-select id="vendorRemit" formControlName="vendorRemit"
                                                                name="vendorRemit">
                                                                <mat-option *ngFor="let dataRemit of this.vendor"
                                                                    [value]="dataRemit.vendorId">{{
                                                                    dataRemit.companyName }}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="align">
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="adminControls">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>Lender</mat-label>
                                                                <input matInput type="text"
                                                                    formControlName="lendorRemit">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="adminControls">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>Internal Vendor Id</mat-label>
                                                                <input matInput type="text"
                                                                    formControlName="internalVendorId">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </mat-card-content>
                                    </mat-card>
                                </div>
                            </div>
                            <mat-card-actions class="mb-3">
                                <div class="buttonRow">
                                    <button mat-raised-button class="search" type="submit"
                                        style="margin-left: 10px;"><mat-icon
                                            class="icon">search</mat-icon>Search</button>
                                    <!-- <button mat-raised-button class="reset" (click)="reset()">Reset</button> -->
                                </div>
                            </mat-card-actions>
                        </form>
                           
                        <mat-card class="mt-3">
                            <mat-card-actions>
                                <div style="text-align:right;">
                                    <button mat-raised-button class="search" (click)="downloadRemitExcel()"><mat-icon
                                            class="nav-icon">download</mat-icon>Download Excel</button>
                                </div>
                            </mat-card-actions>
                            <mat-card-content>
                                <div class="card">
                                    <table mat-table #outerRemitsort="matSort" [dataSource]="remitDataSource"
                                        multiTemplateDataRows class="mat-elevation-z8" matSort>
                                        <ng-container matColumnDef="{{column}}"
                                            *ngFor="let column of displayedRemittanceParentColumns; let i = index">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header [resizeColumn]="true"
                                                [index]="i">
                                                {{
                                                column === 'formattedRemittedDate' ? 'Remit Date' :
                                                column === 'completionDate' ? 'Completion Date' :
                                                column === 'numberOfOrders' ? '# of Orders' :
                                                column === 'refundAmount' ? 'Refund Amount' :
                                                column === 'actualSettlementAmount' ? 'Settle Amount' :
                                                column === 'remittance' ? 'Remittance' : column
                                                }}
                                            </th>
                                            <!-- <td mat-cell *matCellDef="let element">
                                                {{element[column]}}</td> -->

                                            <td mat-cell *matCellDef="let element">
                                                <div *ngIf="column==='actualSettlementAmount' || column==='remittance'; else elseBlock"
                                                    style="text-align: right;">
                                                    {{'$ '+element[column]}}
                                                </div>
                                                <ng-template #elseBlock>
                                                    {{element[column]}}
                                                </ng-template>
                                            </td>
                                        </ng-container>

                                        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                                        <ng-container matColumnDef="expandedDetail">
                                            <td mat-cell *matCellDef="let element"
                                                [attr.colspan]="displayedRemittanceParentColumns.length">
                                                <div class="example-element-detail"
                                                    *ngIf="element.remittedPayments?.data"
                                                    [@detailExpand]="element == expandedRemit ? 'expanded' : 'collapsed'">
                                                    <div class="inner-table mat-elevation-z8" *ngIf="expandedRemit">
                                                        <div class="settleData">
                                                            <button mat-raised-button class="search"
                                                                (click)="downloadInnerRemitExcel(element.remittedPayments.data)"><mat-icon
                                                                    class="nav-icon">download</mat-icon>Download Excel
                                                            </button>
                                                        </div>
                                                        <mat-form-field>
                                                            <input matInput
                                                                (keyup)="applyRemitFilter($event.target.value)"
                                                                placeholder="Filter" />
                                                        </mat-form-field>
                                                        <table #innerRemitTables innerRemitPaginator mat-table
                                                            #innerRemitSort="matSort"
                                                            [dataSource]="element.remittedPayments" matSort>
                                                            <ng-container matColumnDef="{{innerColumn}}"
                                                                *ngFor="let innerColumn of displayedRemittanceChildColumns; let i=index">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                    [resizeColumn]="true" [index]="i">
                                                                    {{
                                                                    innerColumn === 'loanNumber' ? 'Loan Number' :
                                                                    innerColumn === 'borrower' ? 'Borrower Name' :
                                                                    innerColumn === 'propertyAddress' ? 'Property
                                                                    Address' :
                                                                    innerColumn === 'partyName' ? 'Lender Name' :
                                                                    innerColumn === 'orderDate' ? 'Order Date' :
                                                                    innerColumn === 'remittanceDate' ? 'Remit Date' :
                                                                    innerColumn === 'refundAmount' ? 'Refund Amount' :
                                                                    innerColumn === 'formattedActualSettlementAmount'
                                                                    ?'Settle Amount' :
                                                                    innerColumn === 'formattedRemittanceAmount' ?
                                                                    'Remittance Amount' : innerColumn
                                                                    }}

                                                                </th>
                                                                <!-- <td mat-cell *matCellDef="let element">
                                                                    {{element[innerColumn]}}
                                                                </td> -->
                                                                <td mat-cell *matCellDef="let element">
                                                                    <div *ngIf="innerColumn==='formattedActualSettlementAmount' || innerColumn==='formattedRemittanceAmount' || innerColumn==='refundAmount'; else elseBlock"
                                                                        style="text-align: right;">
                                                                        {{element[innerColumn]}}
                                                                    </div>
                                                                    <ng-template #elseBlock>
                                                                        {{element[innerColumn]}}
                                                                    </ng-template>
                                                                </td>
                                                            </ng-container>
                                                            <tr mat-header-row
                                                                *matHeaderRowDef="displayedRemittanceChildColumns">
                                                            </tr>
                                                            <tr mat-row
                                                                *matRowDef="let row; columns: displayedRemittanceChildColumns;">
                                                            </tr>
                                                        </table>
                                                        <mat-card-actions>
                                                            <mat-paginator #innerRemitPaginator [pageSize]="5"
                                                                [length]="element.remittedPayments.data.length"
                                                                [pageIndex]="0"
                                                                [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
                                                        </mat-card-actions>
                                                    </div>
                                                </div>
                                            </td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="displayedRemittanceParentColumns"></tr>
                                        <tr mat-row *matRowDef="let element; columns: displayedRemittanceParentColumns;"
                                            [class.example-element-row]="element.remittedPayments?.data"
                                            [class.example-expanded-row]="expandedRemit === element"
                                            (click)="toggleRemitRow(element)"></tr>
                                        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']"
                                            class="example-detail-row"></tr>
                                    </table>
                                </div>
                                <mat-card-actions>
                                    <div class="text-align mt-3">
                                        <mat-paginator #remitPaginator [pageSize]="5"
                                            [pageSizeOptions]="[5, 10, 25, 100]">
                                        </mat-paginator>
                                    </div>
                                </mat-card-actions>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>

<div id="loadingspinner" *ngIf="isSettleLoading || isRemitLoader || isPaymentLoader">
    <div class="spinner">
        <img src="../../../assets/images/spinner.gif" alt="Loading. Please wait.">
    </div>
</div>

<alert class="alert"></alert>
                        